import i18n from "@/i18n";
import { useUserInfoStore } from "@/stores/userInfo";

export type AppLocale = "zh-CN" | "en-US";

// i18n locale <-> store 里既有的下划线格式互转
const toStoreLang = (loc: AppLocale) => (loc === "zh-CN" ? "zh_CN" : "en_US");
const toLocale = (lang: string): AppLocale =>
  lang === "en_US" ? "en-US" : "zh-CN";

export function currentLocale(): AppLocale {
  return i18n.global.locale.value as AppLocale;
}

export function setLocale(loc: AppLocale): void {
  i18n.global.locale.value = loc;
  const store = useUserInfoStore();
  store.setLanguage(toStoreLang(loc));
}

// 启动时按持久化的 userInfo.language 初始化，默认中文
export function initLocale(): void {
  const store = useUserInfoStore();
  i18n.global.locale.value = toLocale(store.language);
}
